import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import { getLeSectionOptions } from 'app/pages/loanApplication/tabs/loanFees/LoanFeesBody/LoanFeesBody.constants';
import LoanFeeSection from 'app/pages/loanApplication/tabs/loanFees/LoanFeesBody/LoanFeeSection';
import PropTypes from 'prop-types';

import { selectTaxesInsuranceEscrowedLoanFeesView } from 'store/loanApplications/selectors';

import { FeesStepTestIds } from '../../FeesStep.testIds';
import { TOLERANCE_SECTIONS } from '../../feeTolerance.constants';

import { sectionsStyles } from './WizardFeeSections.styles';

const WizardFeeSections = ({ main, editedSection, setEditedSection, isLoading, setIsLoading }) => {
  const taxesInsuranceEscrowed = useSelector(selectTaxesInsuranceEscrowedLoanFeesView);

  const sectionOptions = useMemo(
    () =>
      getLeSectionOptions({ taxesInsuranceEscrowed }).filter(({ cdSection }) =>
        TOLERANCE_SECTIONS.includes(cdSection),
      ),
    [taxesInsuranceEscrowed],
  );

  return (
    <Box data-testid={FeesStepTestIds.FEE_SECTIONS} sx={sectionsStyles}>
      {sectionOptions.map(({ name, description, cdSection, leSection }) => {
        const sectionProps = main[cdSection] || {};

        return (
          <LoanFeeSection
            {...sectionProps}
            cdSection={cdSection}
            description={description}
            editedSection={editedSection}
            isLoading={isLoading}
            key={cdSection}
            leSection={leSection}
            name={name}
            setEditedSection={setEditedSection}
            setIsLoading={setIsLoading}
          />
        );
      })}
    </Box>
  );
};

WizardFeeSections.propTypes = {
  main: PropTypes.object.isRequired,
  setEditedSection: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  editedSection: PropTypes.object,
};

export default memo(WizardFeeSections);
